import Vue from "vue";
import Router from "vue-router";
import { mediums } from "@/util/enums";

import Home from "../pages/home/home.vue";

import Work from "../pages/work.vue";

import Explore from "../pages/explore.vue";
import SavedForLater from "../pages/saved-for-later.vue";
import WorksEngaged from "../pages/works-engaged.vue";
import MediaList from "../pages/media-list.vue";

import PageNotFound from "../pages/page-not-found.vue";
import Rate from "../pages/rate.vue";
import Search from "../pages/search-page.vue";
import Settings from "../pages/settings.vue";
import Profile from "../pages/profile.vue";
import Confirmation from "../pages/rate-confirmation.vue";
import Review from "../pages/review.vue";
import Contacts from "../pages/contacts.vue";
import Login from "../pages/login.vue";
import CreateAccount from "../pages/create-account.vue";

import ForgotPassword from "../pages/password-reset/forgot-password.vue";
import ResetPassword from "../pages/password-reset/reset-password.vue";
import Unsubscribe from "../pages/unsubscribe.vue";

import ImportData from "../pages/import-data.vue";
import Feedback from "../pages/feedback.vue";
import Notifications from "../pages/notifications.vue";

// Policies
import PrivacyPolicy from "../pages/privacy-policy.vue";
import TermsAndConditions from "../pages/terms-and-conditions.vue";

// Dev Tools
import DevTools from "../pages/dev-pages/dev-tools.vue";
import BulkEmail from "../pages/dev-pages/bulk-email.vue";
import DevPlayground from "../pages/dev-pages/dev-playground.vue";

// Admin Tools
import FeedbackReview from "../pages/dev-pages/feedback-review.vue";
import Dashboard from "../pages/dev-pages/dashboard.vue";

import Intro from "../pages/intro.vue";
import UsersMediaLists from "../pages/user-media-lists.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "none",
  routes: [
    { name: "home", path: "/", component: Home },
    { name: "explore", path: "/explore/:medium", component: Explore },
    { name: "rate", path: "/rate", component: Rate },
    {
      name: "rate-confirmation",
      path: "/rate-confirmation",
      component: Confirmation,
    },
    { name: "search", path: "/search", component: Search },
    { name: "settings", path: "/settings", component: Settings },
    { name: "profile", path: "/profile/:username", component: Profile },
    { name: "review", path: "/review/:id", component: Review },
    { name: "contacts", path: "/:username/contacts", component: Contacts },
    { name: "saved-for-later", path: "/u/:username/saved-for-later", component: SavedForLater },
    { name: "works-engaged", path: "/u/:username/works-engaged", component: WorksEngaged },
    { name: "media-list", path: "/u/:username/lists/:listId", component: MediaList },
    { name: "user-media-lists", path: "/u/:username/lists", component: UsersMediaLists },
    { name: "login", path: "/login", component: Login },
    {
      name: "create-account",
      path: "/create-account",
      component: CreateAccount,
    },

    {
      name: "forgot-password",
      path: "/forgot-password",
      component: ForgotPassword,
    },
    {
      name: "reset-password",
      path: "/reset-password/:id/:token",
      component: ResetPassword,
    },
    {
      name: "unsubscribe",
      path: "/unsubscribe/:token",
      component: Unsubscribe,
    },

    {
      name: "work",
      path: `/:medium(${Object.values(mediums).join("|")})/:workId(\\d+):title(-.*)?`,
      component: Work,
    },
    { name: "feedback", path: "/feedback", component: Feedback },
    { name: "notifications", path: "/notifications", component: Notifications },

    { name: "import-data", path: "/import-data", component: ImportData },

    // Dev Pages
    { name: "dev-tools", path: "/dev-tools", component: DevTools },
    { name: "bulk-email", path: "/bulk-email", component: BulkEmail },
    { name: "dev-playground", path: "/dev-tools/playground", component: DevPlayground },

    // Admin Pages
    { name: "dashboard", path: "/dashboard", component: Dashboard },
    {
      name: "feedback-review",
      path: "/feedback-review",
      component: FeedbackReview,
    },

    { name: "intro", path: "/intro", component: Intro },

    // Policies
    {
      name: "privacy-policy",
      path: "/privacy-policy",
      component: PrivacyPolicy,
    },
    {
      name: "terms-and-conditions",
      path: "/terms-and-conditions",
      component: TermsAndConditions,
    },

    { name: "page-not-found", path: "/:pathMatch(.*)*", component: PageNotFound }, //https://router.vuejs.org/guide/essentials/dynamic-matching.html
  ],
});
